(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["oct-member-event"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const STORAGE_VERSION = 4;
    const MAX_DAYS = 7;
    const DAY_IN_MILLISECONDS = 86400000;
    let responsiveLayoutBound = false;

    function syncMemberEventResponsiveLayout(root) {
      if (!root) return;

      const viewportWidth = window.innerWidth || document.documentElement.clientWidth || root.clientWidth || 0;

      if (viewportWidth < 750) {
        root.style.removeProperty('--oct-member-event-scale');
        root.style.removeProperty('--oct-member-event-missions-padding');
        root.style.removeProperty('--oct-member-event-rules-padding');
        root.style.removeProperty('--oct-member-event-rewards-padding');
        return;
      }

      const contentWidth = root.clientWidth || document.documentElement.clientWidth || viewportWidth;
      const scale = Math.min(1, contentWidth / 1606);

      root.style.setProperty('--oct-member-event-scale', scale.toFixed(4));
      root.style.setProperty('--oct-member-event-missions-padding', `${Math.round(115 * scale)}px`);
      root.style.setProperty('--oct-member-event-rules-padding', `${Math.round(120 * scale)}px`);
      root.style.setProperty('--oct-member-event-rewards-padding', `${Math.round(136 * scale)}px`);
    }

    function clampDay(day) {
      return Math.min(MAX_DAYS, Math.max(1, Number(day) || 1));
    }

    function getDateKey(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');

      return `${year}-${month}-${day}`;
    }

    function getRelativeDateKey(offset) {
      const date = new Date();
      date.setDate(date.getDate() + offset);
      return getDateKey(date);
    }

    function getUtcDayNumber(dateKey) {
      const parts = String(dateKey || '')
        .split('-')
        .map(Number);

      if (parts.length !== 3 || parts.some((part) => !Number.isFinite(part))) return NaN;

      return Date.UTC(parts[0], parts[1] - 1, parts[2]);
    }

    function getDateDifference(fromDateKey, toDateKey) {
      const from = getUtcDayNumber(fromDateKey);
      const to = getUtcDayNumber(toDateKey);

      if (!Number.isFinite(from) || !Number.isFinite(to)) return NaN;

      return Math.round((to - from) / DAY_IN_MILLISECONDS);
    }

    function createInitialState() {
      return {
        version: STORAGE_VERSION,
        source: 'local',
        activityDay: 1,
        streak: 0,
        lastCheckInDate: '',
        activityDate: '',
        todayCheckin: false,
        todayJump: false,
        todayCompleted: false,
        rewardsGranted: [],
        completed: false,
        participantsCount: 1234,
        actionPending: false,
        tasks: {},
        rewardClaims: {},
      };
    }

    function normalizeState(value) {
      const state = createInitialState();

      if (!value || typeof value !== 'object') return state;

      state.source = value.source === 'remote' ? 'remote' : 'local';
      state.streak = Math.min(MAX_DAYS, Math.max(0, Number(value.streak) || 0));
      state.activityDay = clampDay(
        value.activityDay || value.streakDay || (state.streak >= MAX_DAYS ? MAX_DAYS : state.streak + 1)
      );
      state.lastCheckInDate = typeof value.lastCheckInDate === 'string' ? value.lastCheckInDate : '';
      state.activityDate = typeof value.activityDate === 'string' ? value.activityDate : '';
      state.todayCheckin = Boolean(value.todayCheckin);
      state.todayJump = Boolean(value.todayJump);
      state.todayCompleted = Boolean(value.todayCompleted || (state.todayCheckin && state.todayJump));
      state.completed = Boolean(value.completed);
      state.participantsCount = Number.isFinite(Number(value.participantsCount))
        ? Math.max(0, Math.round(Number(value.participantsCount)))
        : 1234;

      if (value.tasks && typeof value.tasks === 'object') {
        Object.keys(value.tasks).forEach((key) => {
          if (value.tasks[key]) state.tasks[key] = true;
        });
      }

      if (Array.isArray(value.rewardsGranted)) {
        state.rewardsGranted = value.rewardsGranted.slice();
      }

      if (value.rewardClaims && typeof value.rewardClaims === 'object') {
        Object.keys(value.rewardClaims).forEach((key) => {
          if (value.rewardClaims[key]) state.rewardClaims[key] = value.rewardClaims[key];
        });
      }

      if (state.source !== 'remote' && state.lastCheckInDate) {
        const daysSinceCheckIn = getDateDifference(state.lastCheckInDate, getDateKey(new Date()));

        if (!Number.isFinite(daysSinceCheckIn) || daysSinceCheckIn < 0 || daysSinceCheckIn > 1) {
          state.activityDay = 1;
          state.streak = 0;
          state.lastCheckInDate = '';
          state.activityDate = '';
          state.todayCheckin = false;
          state.todayJump = false;
          state.todayCompleted = false;
          state.completed = false;
          state.tasks = {};
        }
      }

      return state;
    }

    function renderParticipantsCount(root, state) {
      const count = root.querySelector('[data-oct-participants-count]');

      if (!count || !Number.isFinite(Number(state.participantsCount))) return;

      count.textContent = Number(state.participantsCount).toLocaleString('en-US');
    }

    function getStorageKey(root) {
      const eventKey = root.dataset.eventKey || root.id || 'default';
      const customerKey = root.dataset.customerKey || 'guest';

      return `${eventKey}:${customerKey}:v${STORAGE_VERSION}`;
    }

    function readStoredState(root) {
      try {
        const rawState = window.localStorage.getItem(getStorageKey(root));
        return rawState ? normalizeState(JSON.parse(rawState)) : null;
      } catch (error) {
        return null;
      }
    }

    function saveState(root, state) {
      try {
        window.localStorage.setItem(getStorageKey(root), JSON.stringify(state));
      } catch (error) {
        // Storage can be unavailable in private browsing or when cookies are blocked.
      }
    }

    function isCustomerAuthenticated(root) {
      return root.dataset.customerAuthenticated === 'true';
    }

    function requestMemberEventLogin(root) {
      const loginEvent = new CustomEvent('oct:member-event-login-required', {
        bubbles: true,
        cancelable: true,
        detail: {
          eventKey: root.dataset.eventKey || '',
          returnUrl: window.location.href,
        },
      });

      root.dispatchEvent(loginEvent);

      if (loginEvent.defaultPrevented) return true;

      const loginUrl = root.dataset.loginUrl;
      if (!loginUrl) return false;

      try {
        const url = new URL(loginUrl, window.location.origin);
        if (!url.searchParams.has('return_to')) {
          url.searchParams.set(
            'return_to',
            `${window.location.pathname}${window.location.search}${window.location.hash}`
          );
        }
        window.location.assign(url.toString());
      } catch (error) {
        window.location.assign(loginUrl);
      }

      return true;
    }

    function getInitialState(root) {
      if (isCustomerAuthenticated(root)) return createInitialState();

      const storedState = readStoredState(root);

      if (storedState) return storedState;

      const state = createInitialState();

      saveState(root, state);
      return state;
    }

    function getProgressDay(state) {
      return state.completed ? MAX_DAYS : clampDay(state.activityDay || state.streak + 1);
    }

    function getCompletedDayCount(state) {
      if (state.completed) return MAX_DAYS;

      return Math.min(MAX_DAYS, Math.max(0, Number(state.streak) || getProgressDay(state) - 1));
    }

    function isTodayCompleted(state) {
      if (state.source === 'remote') {
        return Boolean(state.todayCompleted || (state.todayCheckin && state.todayJump));
      }

      return state.todayCheckin && state.todayJump && state.lastCheckInDate === getDateKey(new Date());
    }

    function getVisibleDay(state) {
      return getProgressDay(state);
    }

    function getActivityResponseData(payload) {
      if (!payload || typeof payload !== 'object') return {};

      if (payload.data && typeof payload.data === 'object') return payload.data;
      if (payload.status && typeof payload.status === 'object') return payload.status;

      return payload;
    }

    function getActivityResponseValue(data, camelKey, snakeKey) {
      if (Object.prototype.hasOwnProperty.call(data, camelKey)) return data[camelKey];
      if (snakeKey && Object.prototype.hasOwnProperty.call(data, snakeKey)) return data[snakeKey];

      return undefined;
    }

    function toActivityBoolean(value) {
      return value === true || value === 1 || value === '1' || value === 'true';
    }

    function normalizeRewardsGranted(value) {
      if (!Array.isArray(value)) return [];

      return Array.from(
        new Set(
          value
            .map((item) => {
              if (item && typeof item === 'object') {
                if (Object.prototype.hasOwnProperty.call(item, 'received') && !toActivityBoolean(item.received)) {
                  return 0;
                }

                return Number(item.day || item.dayNumber || item.day_number);
              }

              return Number(String(item).replace(/^day-/, ''));
            })
            .filter((day) => Number.isInteger(day) && day >= 1 && day <= MAX_DAYS)
        )
      );
    }

    function normalizeRemoteActivityState(payload) {
      const data = getActivityResponseData(payload);
      const streakData = data.streak && typeof data.streak === 'object' ? data.streak : {};
      const todayData = data.today && typeof data.today === 'object' ? data.today : {};
      const streakCountValue =
        streakData.streakCount ??
        streakData.streak_count ??
        getActivityResponseValue(data, 'streakCount', 'streak_count');
      const streakCount = Math.max(0, Number(streakCountValue) || 0);
      const completed = toActivityBoolean(streakData.completed ?? data.completed) || streakCount >= MAX_DAYS;
      const lastCompletedDate =
        typeof data.lastCompletedDate === 'string'
          ? data.lastCompletedDate
          : typeof getActivityResponseValue(data, 'lastActiveDate', 'last_active_date') === 'string'
          ? getActivityResponseValue(data, 'lastActiveDate', 'last_active_date')
          : '';
      const nextActivityDay = clampDay(
        completed
          ? MAX_DAYS
          : streakData.currentDay ??
              streakData.current_day ??
              getActivityResponseValue(data, 'streakDay', 'streak_day') ??
              getActivityResponseValue(data, 'currentDay', 'current_day') ??
              streakCount + 1
      );
      const todayCheckin = toActivityBoolean(
        todayData.checkinDone ??
          todayData.checkin_done ??
          getActivityResponseValue(data, 'todayCheckin', 'today_checkin')
      );
      const todayJump = toActivityBoolean(
        todayData.jumpDone ?? todayData.jump_done ?? getActivityResponseValue(data, 'todayJump', 'today_jump')
      );
      const todayCompleted =
        toActivityBoolean(todayData.completed ?? getActivityResponseValue(data, 'todayCompleted', 'today_completed')) ||
        (todayCheckin && todayJump);
      const activityDate = typeof todayData.date === 'string' ? todayData.date : '';
      const completedOnCurrentActivityDate =
        todayCompleted && (!activityDate || !lastCompletedDate || activityDate === lastCompletedDate);
      const activityDay =
        completedOnCurrentActivityDate && !completed ? clampDay(nextActivityDay - 1) : nextActivityDay;
      const rewardsGranted = normalizeRewardsGranted(
        data.rewards || getActivityResponseValue(data, 'rewardsGranted', 'rewards_granted')
      );
      const participantsCountValue = getActivityResponseValue(data, 'participantsCount', 'participants_count');
      const state = createInitialState();

      state.source = 'remote';
      state.activityDay = activityDay;
      state.streak = completed ? MAX_DAYS : Math.min(MAX_DAYS, streakCount || Math.max(0, activityDay - 1));
      state.lastCheckInDate =
        lastCompletedDate || (typeof activityDate === 'string' && todayCheckin ? activityDate : '');
      state.activityDate = activityDate;
      state.todayCheckin = todayCheckin;
      state.todayJump = todayJump;
      state.todayCompleted = todayCompleted;
      state.rewardsGranted = rewardsGranted;
      state.completed = completed;
      state.participantsCount = Number.isFinite(Number(participantsCountValue))
        ? Math.max(0, Math.round(Number(participantsCountValue)))
        : state.participantsCount;

      for (let day = 1; day < activityDay; day += 1) {
        state.tasks[`day-${day}-task-1`] = true;
        state.tasks[`day-${day}-task-2`] = true;
      }

      if (todayCheckin) state.tasks[`day-${activityDay}-task-1`] = true;
      if (todayJump) state.tasks[`day-${activityDay}-task-2`] = true;

      if (completed) {
        for (let day = 1; day <= MAX_DAYS; day += 1) {
          state.tasks[`day-${day}-task-1`] = true;
          state.tasks[`day-${day}-task-2`] = true;
        }
      }

      rewardsGranted.forEach((day) => {
        state.rewardClaims[`day-${day}`] = true;
      });

      return state;
    }

    function getActivityApiUrl(root, endpoint) {
      const apiBase = String(
        root.dataset.activityApiBase || 'https://googoohair-member-event-activity.hlts-dtc.workers.dev'
      ).replace(/\/+$/, '');
      const baseUrl = /^https?:\/\//i.test(apiBase)
        ? apiBase
        : new URL(apiBase, window.location.origin).toString().replace(/\/+$/, '');

      return new URL(`${baseUrl}/${endpoint}`);
    }

    async function requestActivity(root, endpoint, method) {
      const url = getActivityApiUrl(root, endpoint);
      const customerId = String(root.dataset.customerId || '').trim();
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 10000);
      const requestOptions = {
        method,
        cache: 'no-store',
        credentials: 'omit',
        headers: {
          Accept: 'application/json',
        },
        signal: controller.signal,
      };

      if (method === 'GET') {
        if (customerId) url.searchParams.set('customerId', customerId);
      } else {
        requestOptions.body = JSON.stringify({ customerId });
        requestOptions.headers['Content-Type'] = 'application/json';
      }

      try {
        const response = await fetch(url.toString(), requestOptions);
        let payload = {};

        try {
          payload = await response.json();
        } catch (error) {
          payload = {};
        }

        if (!response.ok || payload.error) {
          const message = payload.message || payload.error || `Activity API request failed (${response.status})`;
          throw new Error(message);
        }

        return payload;
      } catch (error) {
        if (error && error.name === 'AbortError') {
          throw new Error(`${endpoint} request timed out.`);
        }

        throw error;
      } finally {
        window.clearTimeout(timeout);
      }
    }

    function normalizeMissionPath(path) {
      const normalizedPath = String(path || '/').replace(/\/+$/, '');

      return normalizedPath || '/';
    }

    function prepareMissionJump(root, action, day) {
      if (!action || !action.href) return null;

      try {
        const destination = new URL(action.href, window.location.href);
        if (['googoohair.com', 'www.googoohair.com', window.location.hostname].includes(destination.hostname)) {
          destination.protocol = window.location.protocol;
          destination.host = window.location.host;
        }
        const eventKey = root.dataset.eventKey || 'oct-member-event';
        const intent = {
          apiBase: root.dataset.activityApiBase || '',
          createdAt: Date.now(),
          customerId: String(root.dataset.customerId || ''),
          day,
          eventKey,
          targetPath: normalizeMissionPath(destination.pathname),
        };

        if (destination.origin === window.location.origin) {
          destination.searchParams.set('oct_member_event', '1');
          destination.searchParams.set('mission_day', String(day));
          destination.searchParams.set('mission_task', 'jump');
          destination.searchParams.set('event_key', eventKey);

          try {
            window.sessionStorage.setItem('oct-member-event:jump-intent:v1', JSON.stringify(intent));
          } catch (error) {
            // Storage is only used to authorize /jump; it must not block the page navigation.
          }
        }

        return destination;
      } catch (error) {
        return null;
      }
    }

    function publishActivityApiError(root, error, endpoint) {
      root.dispatchEvent(
        new CustomEvent('oct:member-event-api-error', {
          bubbles: true,
          detail: {
            eventKey: root.dataset.eventKey || '',
            endpoint,
            message: error && error.message ? error.message : 'Activity API request failed.',
          },
        })
      );
    }

    function isMobileMemberEvent(root) {
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth || root.clientWidth || 0;

      return viewportWidth < 750;
    }

    function setMobileDayIndicator(root, activeDay) {
      const indicator = root.querySelector('[data-oct-day-indicator]');

      if (!indicator) return;

      const normalizedDay = clampDay(activeDay);

      indicator.querySelectorAll('[data-oct-day-indicator-item]').forEach((item) => {
        const isActive = Number(item.dataset.day) === normalizedDay;

        item.classList.toggle('is-active', isActive);
      });
    }

    function updateMobileDayIndicator(root) {
      if (!isMobileMemberEvent(root)) return;

      const days = root.querySelector('.oct-member-event__days');
      const cards = days ? Array.from(days.querySelectorAll('[data-oct-day-card]')) : [];
      if (!days || !cards.length) return;

      const maxScrollLeft = Math.max(0, days.scrollWidth - days.clientWidth);
      if (days.scrollLeft <= 1 || !maxScrollLeft) {
        setMobileDayIndicator(root, 1);
        return;
      }
      if (days.scrollLeft >= maxScrollLeft - 1) {
        setMobileDayIndicator(root, MAX_DAYS);
        return;
      }

      const firstCardLeft = cards[0].offsetLeft;
      const viewportCenter = days.scrollLeft + days.clientWidth / 2;
      const activeCard = cards.reduce((closest, card) => {
        const center = card.offsetLeft - firstCardLeft + card.offsetWidth / 2;
        const closestCenter = closest.offsetLeft - firstCardLeft + closest.offsetWidth / 2;
        return Math.abs(center - viewportCenter) < Math.abs(closestCenter - viewportCenter) ? card : closest;
      }, cards[0]);

      setMobileDayIndicator(root, Number(activeCard.dataset.day));
    }

    function scrollMobileDaysToDay(root, day, behavior) {
      if (!isMobileMemberEvent(root)) return;

      const days = root.querySelector('.oct-member-event__days');
      const cards = days ? Array.from(days.querySelectorAll('[data-oct-day-card]')) : [];
      const targetCard = cards.find((card) => Number(card.dataset.day) === Number(day));

      if (!days || !targetCard) return;

      const targetLeft = targetCard.offsetLeft - cards[0].offsetLeft + (targetCard.offsetWidth - days.clientWidth) / 2;
      const maxScrollLeft = Math.max(0, days.scrollWidth - days.clientWidth);
      const left = Math.min(Math.max(0, targetLeft), maxScrollLeft);

      if (behavior === 'smooth') {
        days.scrollTo({ left, behavior: 'smooth' });
      } else {
        days.scrollLeft = left;
      }

      setMobileDayIndicator(root, Number(day));
    }

    function bindMobileDayScroller(root) {
      const days = root.querySelector('.oct-member-event__days');

      if (!days || days.dataset.octDayScrollerBound === 'true') return;

      let framePending = false;

      days.addEventListener(
        'scroll',
        () => {
          if (framePending) return;

          framePending = true;
          window.requestAnimationFrame(() => {
            framePending = false;
            updateMobileDayIndicator(root);
          });
        },
        { passive: true }
      );
      days.dataset.octDayScrollerBound = 'true';
    }

    function isTabSelectable(tab, state) {
      const day = Number(tab.dataset.day);
      const progressDay = getProgressDay(state);

      return state.completed || day <= progressDay;
    }

    function getTaskRows(panel) {
      return Array.from(panel.querySelectorAll('[data-oct-task-row]'));
    }

    function renderRewardState(panel, state) {
      const rewardPanel = panel.querySelector('[data-oct-reward-panel]');

      if (!rewardPanel) return;

      const day = Number(panel.dataset.day);
      const rewardKey = `day-${day}`;
      const rewardType = rewardPanel.dataset.rewardType === 'points' ? 'points' : 'coupon_points';
      const isPastDay = day < getProgressDay(state);
      const rewardState = isPastDay && state.rewardClaims[rewardKey] ? 'issued' : rewardType;

      rewardPanel.dataset.rewardState = rewardState;
      rewardPanel.querySelectorAll('[data-oct-reward-view]').forEach((view) => {
        view.hidden = view.dataset.octRewardView !== rewardState;
      });
    }

    function publishState(root, state) {
      root.dispatchEvent(
        new CustomEvent('oct:member-event-state-change', {
          bubbles: true,
          detail: {
            eventKey: root.dataset.eventKey,
            customerKey: root.dataset.customerKey,
            streak: getCompletedDayCount(state),
            lastCheckInDate: state.lastCheckInDate,
            currentDay: getProgressDay(state),
            todayCheckin: state.todayCheckin,
            todayJump: state.todayJump,
            todayCompleted: isTodayCompleted(state),
            source: state.source,
            tasks: Object.assign({}, state.tasks),
            rewardClaims: Object.assign({}, state.rewardClaims),
          },
        })
      );
    }

    function renderMissionState(root, state, tabs, panels) {
      const progressDay = getProgressDay(state);
      const activeRewardTemplate = root.querySelector('[data-oct-active-day-reward]');
      const checkRewardTemplate = root.querySelector('[data-oct-check-day-reward]');
      const statusClasses = [
        'oct-member-event__day-card--complete',
        'oct-member-event__day-card--today',
        'oct-member-event__day-card--tomorrow',
        'oct-member-event__day-card--not_started',
      ];
      const progressCount = root.querySelector('[data-oct-progress-count]');
      const labels = JSON.parse(root.querySelector('[data-oct-status-labels]').textContent);

      renderParticipantsCount(root, state);
      if (progressCount) progressCount.textContent = `${getCompletedDayCount(state)} / ${MAX_DAYS}`;
      setMobileDayIndicator(root, progressDay);

      tabs.forEach((tab) => {
        const day = Number(tab.dataset.day);
        const isComplete = day < progressDay;
        const isCurrent = day === progressDay;
        const isTomorrow = day === progressDay + 1 && progressDay < MAX_DAYS;
        const reward = tab.querySelector('.oct-member-event__day-reward');
        const status = tab.querySelector('.oct-member-event__day-status');

        tab.classList.remove(...statusClasses);
        tab.classList.add(
          isComplete
            ? 'oct-member-event__day-card--complete'
            : isCurrent
            ? 'oct-member-event__day-card--today'
            : isTomorrow
            ? 'oct-member-event__day-card--tomorrow'
            : 'oct-member-event__day-card--not_started'
        );
        tab.classList.toggle('is-active', isCurrent);

        if (isCurrent) {
          tab.setAttribute('aria-current', 'step');
        } else {
          tab.removeAttribute('aria-current');
        }

        const isSelectable = isTabSelectable(tab, state);
        tab.classList.toggle('is-selectable', isSelectable);
        tab.disabled = !isSelectable;
        tab.setAttribute('aria-disabled', String(!isSelectable));

        if (status) {
          const statusKey = isComplete ? 'complete' : isCurrent ? 'today' : isTomorrow ? 'tomorrow' : 'not_started';
          status.textContent =
            tab.dataset.previewStatus === statusKey && tab.dataset.statusText
              ? tab.dataset.statusText
              : labels[statusKey];
        }

        if (reward) {
          if (!reward.dataset.defaultMarkup) {
            reward.dataset.defaultMarkup = reward.innerHTML;
            reward.dataset.defaultSymbol = reward.classList.contains('oct-member-event__day-reward--symbol')
              ? 'true'
              : 'false';
          }

          if (isComplete) {
            reward.classList.add('oct-member-event__day-reward--symbol');
            reward.innerHTML = checkRewardTemplate
              ? checkRewardTemplate.innerHTML
              : '<span aria-hidden="true">✓</span>';
          } else if (isCurrent && reward.dataset.defaultSymbol === 'true' && activeRewardTemplate) {
            reward.innerHTML = activeRewardTemplate.innerHTML;
            reward.classList.add('oct-member-event__day-reward--symbol');
          } else {
            reward.innerHTML = reward.dataset.defaultMarkup;
            reward.classList.toggle('oct-member-event__day-reward--symbol', reward.dataset.defaultSymbol === 'true');
          }
        }
      });

      panels.forEach((panel) => {
        const day = Number(panel.dataset.day);
        const rows = getTaskRows(panel);
        const isDayComplete = day < progressDay;
        let completedTaskCount = 0;

        rows.forEach((row) => {
          const action = row.querySelector('[data-oct-task-action]');
          const isComplete = Boolean(state.tasks[row.dataset.taskKey]);

          if (isComplete) completedTaskCount += 1;
          row.classList.toggle('is-complete', isComplete);

          if (!action) return;

          if (!action.dataset.defaultLabel) action.dataset.defaultLabel = action.textContent.trim();
          const taskKind = action.dataset.taskKind || 'task';
          const completeLabel = action.dataset.completeLabel || 'Completed';
          const configuredPendingLabel = action.dataset.pendingLabel || action.dataset.defaultLabel;
          const pendingLabel =
            configuredPendingLabel && configuredPendingLabel.toLowerCase() !== completeLabel.toLowerCase()
              ? configuredPendingLabel
              : taskKind === 'check-in'
              ? 'Check In'
              : 'Learn More';

          const actionLabel = action.querySelector('[data-oct-task-action-label]') || action;
          actionLabel.textContent = isComplete ? completeLabel : pendingLabel;

          const isLocked = isComplete || state.actionPending;

          row.classList.toggle('is-day-complete', isDayComplete);

          action.setAttribute('aria-disabled', String(isLocked));
          action.setAttribute('aria-busy', String(state.actionPending && !isLocked));
          if (action.tagName === 'BUTTON') {
            action.disabled = isLocked;
          } else {
            action.tabIndex = isLocked ? -1 : 0;
          }
        });

        const progressValue = panel.querySelector('[data-oct-task-complete]');
        if (progressValue) progressValue.textContent = completedTaskCount;

        renderRewardState(panel, state);
      });
    }

    function initMemberEvent(root) {
      if (!root || root.dataset.octMemberEventInitialized === 'true') return;

      syncMemberEventResponsiveLayout(root);

      const tabs = Array.from(root.querySelectorAll('[data-oct-day-card]'));
      const panels = Array.from(root.querySelectorAll('[data-oct-day-panel]'));
      let remoteRequestPromise = null;
      let statusRefreshTimer = null;
      let lastStatusSyncAt = 0;

      if (!tabs.length || !panels.length) return;

      const state = getInitialState(root);
      bindMobileDayScroller(root);

      function selectDay(tab) {
        if (!tab) return;

        const day = tab.dataset.day;

        tabs.forEach((item) => {
          const isSelected = item === tab;
          item.classList.toggle('is-selected', isSelected);
          item.setAttribute('aria-selected', String(isSelected));
          item.tabIndex = isSelected ? 0 : -1;
        });

        panels.forEach((panel) => {
          const isSelected = panel.dataset.day === day;
          panel.classList.toggle('is-active', isSelected);
          panel.hidden = !isSelected;
        });

        root.dispatchEvent(
          new CustomEvent('oct:day-change', {
            bubbles: true,
            detail: { day: Number(day) },
          })
        );
      }

      function activateDay(tab) {
        if (!tab || !isTabSelectable(tab, state)) return;
        selectDay(tab);
      }

      async function handleTaskAction(event) {
        const action = event.currentTarget;
        const panel = action.closest('[data-oct-day-panel]');
        const row = action.closest('[data-oct-task-row]');

        if (!panel || !row) return;

        if (!isCustomerAuthenticated(root)) {
          event.preventDefault();
          requestMemberEventLogin(root);
          return;
        }

        const day = Number(panel.dataset.day);
        const taskKind = action.dataset.taskKind || 'task';

        if (taskKind === 'check-in' || action.tagName === 'A') event.preventDefault();

        if (remoteRequestPromise) {
          await remoteRequestPromise;
        }

        const isLockedAfterPendingRequest = action.getAttribute('aria-disabled') === 'true';

        if (isLockedAfterPendingRequest) {
          if (action.tagName === 'A') event.preventDefault();
          return;
        }

        if (taskKind !== 'check-in') {
          const destination = prepareMissionJump(root, action, day);

          if (destination) window.location.assign(destination.toString());
          return;
        }

        await updateRemoteState('checkin', 'POST', true);
      }

      async function updateRemoteState(endpoint, method, scrollToCurrent = false) {
        if (!isCustomerAuthenticated(root) && endpoint !== 'status') return;
        if (remoteRequestPromise) return remoteRequestPromise;

        const previousVisibleDay = getVisibleDay(state);
        const isActionRequest = endpoint !== 'status';

        remoteRequestPromise = (async () => {
          if (isActionRequest) {
            state.actionPending = true;
            renderMissionState(root, state, tabs, panels);
          }

          try {
            const payload = await requestActivity(root, endpoint, method);
            const responseData = getActivityResponseData(payload);
            const participantsCountValue = getActivityResponseValue(
              responseData,
              'participantsCount',
              'participants_count'
            );

            if (Number.isFinite(Number(participantsCountValue))) {
              state.participantsCount = Math.max(0, Math.round(Number(participantsCountValue)));
            }

            if (endpoint === 'status' && !isCustomerAuthenticated(root)) {
              renderParticipantsCount(root, state);
              return;
            }

            const nextState = normalizeRemoteActivityState(payload);

            nextState.actionPending = isActionRequest;
            Object.assign(state, nextState);
            renderMissionState(root, state, tabs, panels);

            const nextVisibleDay = getVisibleDay(state);
            if (previousVisibleDay !== nextVisibleDay) {
              const nextTab = tabs.find((tab) => Number(tab.dataset.day) === nextVisibleDay);
              if (nextTab) selectDay(nextTab);
            }

            if (scrollToCurrent || previousVisibleDay !== nextVisibleDay) {
              scrollMobileDaysToDay(root, getProgressDay(state), scrollToCurrent ? 'smooth' : undefined);
            }
          } catch (error) {
            publishActivityApiError(root, error, endpoint);
          } finally {
            root.dataset.octMemberEventStatusPending = 'false';
            if (isActionRequest) {
              state.actionPending = false;
              renderMissionState(root, state, tabs, panels);
            }
            publishState(root, state);
          }
        })();

        try {
          await remoteRequestPromise;
        } finally {
          remoteRequestPromise = null;
        }
      }

      async function syncRemoteState() {
        if (remoteRequestPromise) return remoteRequestPromise;

        const now = Date.now();
        if (now - lastStatusSyncAt < 1000) return;

        lastStatusSyncAt = now;
        await updateRemoteState('status', 'GET');
      }

      function refreshDateState() {
        if (isCustomerAuthenticated(root)) {
          void syncRemoteState();
          return;
        }

        const previousVisibleDay = getVisibleDay(state);
        const nextState = normalizeState(state);
        const nextVisibleDay = getVisibleDay(nextState);

        Object.assign(state, nextState);
        saveState(root, state);
        renderMissionState(root, state, tabs, panels);

        if (previousVisibleDay !== nextVisibleDay) {
          const nextTab = tabs.find((tab) => Number(tab.dataset.day) === nextVisibleDay);
          if (nextTab) selectDay(nextTab);
          scrollMobileDaysToDay(root, getProgressDay(state));
        }

        publishState(root, state);
      }

      function scheduleDateStateRefresh() {
        if (statusRefreshTimer !== null) return;

        statusRefreshTimer = window.setTimeout(() => {
          statusRefreshTimer = null;
          refreshDateState();
        }, 100);
      }

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          if (!isTabSelectable(tab, state)) return;
          activateDay(tab);
        });
        tab.addEventListener('keydown', (event) => {
          if (!isTabSelectable(tab, state)) return;

          const isNavigationKey = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp', 'Home', 'End'].includes(
            event.key
          );

          if (!isNavigationKey) return;

          let nextIndex = index;

          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex += 1;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex -= 1;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;

          while (nextIndex >= 0 && nextIndex < tabs.length && !isTabSelectable(tabs[nextIndex], state)) {
            nextIndex += event.key === 'ArrowLeft' || event.key === 'ArrowUp' ? -1 : 1;
          }

          if (nextIndex === index || nextIndex < 0 || nextIndex >= tabs.length) return;

          event.preventDefault();
          tabs[nextIndex].focus();
          selectDay(tabs[nextIndex]);
        });
      });

      root.querySelectorAll('[data-oct-task-action]').forEach((action) => {
        action.addEventListener('click', handleTaskAction);
      });

      root.dataset.octMemberEventInitialized = 'true';
      renderMissionState(root, state, tabs, panels);

      const initialTab = tabs.find((tab) => Number(tab.dataset.day) === getVisibleDay(state)) || tabs[0];
      selectDay(initialTab);
      scrollMobileDaysToDay(root, getProgressDay(state));
      publishState(root, state);
      const handleWindowFocus = scheduleDateStateRefresh;
      const handleVisibilityChange = () => {
        if (!document.hidden) scheduleDateStateRefresh();
      };
      const handlePageShow = () => {
        scheduleDateStateRefresh();
      };
      window.addEventListener('focus', handleWindowFocus);
      document.addEventListener('visibilitychange', handleVisibilityChange);
      window.addEventListener('pageshow', handlePageShow);
      root.__octMemberEventCleanup = () => {
        if (statusRefreshTimer !== null) {
          window.clearTimeout(statusRefreshTimer);
          statusRefreshTimer = null;
        }
        window.removeEventListener('focus', handleWindowFocus);
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        window.removeEventListener('pageshow', handlePageShow);
        delete root.__octMemberEventCleanup;
      };

      void syncRemoteState();
    }

    function initAllMemberEvents(scope) {
      const container = scope || document;
      const roots = [];

      if (container.matches && container.matches('[data-oct-member-event]')) roots.push(container);
      if (container.querySelectorAll) {
        roots.push(...container.querySelectorAll('[data-oct-member-event]'));
      }

      roots.forEach(initMemberEvent);

      if (!responsiveLayoutBound) {
        window.addEventListener(
          'resize',
          () => {
            document.querySelectorAll('[data-oct-member-event]').forEach(syncMemberEventResponsiveLayout);
          },
          { passive: true }
        );
        responsiveLayoutBound = true;
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAllMemberEvents(), { once: true });
    } else {
      initAllMemberEvents();
    }

    if (!window.__octMemberEventSectionLifecycleBound) {
      window.__octMemberEventSectionLifecycleBound = true;
      document.addEventListener('shopify:section:load', (event) => {
        initAllMemberEvents(event.target);
      });
      document.addEventListener('shopify:section:unload', (event) => {
        const container = event.target;
        const roots = [];

        if (container.matches && container.matches('[data-oct-member-event]')) roots.push(container);
        if (container.querySelectorAll) {
          roots.push(...container.querySelectorAll('[data-oct-member-event]'));
        }

        roots.forEach((memberEventRoot) => {
          if (typeof memberEventRoot.__octMemberEventCleanup === 'function') {
            memberEventRoot.__octMemberEventCleanup();
          }
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
